import { useEffect } from 'react';
import { PaymentSource } from '../../constants';
import {
  CartUpdateAction,
  CartUpdatePropertyName,
  useCart,
  useUpdateCartMutation
} from '../useCart';
import { useIsAffirmEnabled } from '../useIsAffirmEnabled';

export const useSanitizePaymentSource = () => {
  const { cart } = useCart();
  const isAffirmEnabled = useIsAffirmEnabled();
  const [updateCart] = useUpdateCartMutation();

  const shouldChangeToCard =
    cart.attributes.paymentSource === PaymentSource.Affirm ||
    (cart.attributes.paymentSource === PaymentSource.BraintreeAffirm && !isAffirmEnabled);

  useEffect(() => {
    if (shouldChangeToCard) {
      updateCart(CartUpdateAction.PaymentSource, {
        [CartUpdatePropertyName.PaymentSource]: PaymentSource.Braintree
      });
    }
  }, [shouldChangeToCard, updateCart]);

  return {
    loading: shouldChangeToCard
  };
};
